import cn from 'classnames'
import { STATUS_OPTIONS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/configs'
import { FC, useCallback } from 'react'

import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'
import {
  getKeyInitiativeStatusTranslationKey,
  normalizeKeyInitiativeStatus,
} from 'partner360/entities/keyInitiatives/model/status'

import styles from './StatusButtons.module.scss'

interface IStatusButtonsProps {
  className?: string
  initialValue?: string
  isDisabled?: boolean
  formKey: string
}

export const StatusButtons: FC<IStatusButtonsProps> = ({
  className,
  initialValue = '',
  isDisabled,
  formKey,
}) => {
  const {
    value: selectedStatus,
    handleChange,
    validationMessage,
  } = useFormField<string>({
    defaultValue: initialValue,
    formKey,
    field: 'status',
    isRequired: true,
    isDisabled,
    validationType: ValidationType.ONCHANGE,
  })

  const handleClick = useCallback(
    (statusKey: string) => {
      if (isDisabled) {
        return
      }

      handleChange(statusKey)
    },
    [isDisabled, handleChange]
  )

  return (
    <div className={cn(styles.root, className)}>
      <Tooltip disabled={!validationMessage} tipContent={() => <>{validationMessage}</>}>
        <div className={cn(styles.container, { [styles.invalid]: validationMessage })}>
          <div className={styles.segmented}>
            {STATUS_OPTIONS.map((status) => {
              const isActive = normalizeKeyInitiativeStatus(selectedStatus) === status.key

              return (
                <button
                  key={status.key}
                  type="button"
                  disabled={isDisabled}
                  className={cn(styles.item, { [styles.active]: isActive })}
                  style={isActive && status.color ? { backgroundColor: status.color } : undefined}
                  onClick={() => handleClick(status.key)}
                >
                  <Translation text={getKeyInitiativeStatusTranslationKey(status.key)} span />
                </button>
              )
            })}
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

StatusButtons.displayName = 'StatusButtons'
